var screens = {
    list: function(page){
        var params = {
            page: (page || 1),
            like: $('#like').val(),
            screen_type: $('#screen-list-screen_type').val(),
        };

        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState)
        {
            window.history.replaceState(null, null, getParams);

            $.get(getParams, params, function(resp){
                $("#screen_list").html(resp);
            });
        } else {
            location.href=getParams;
        }
    },
    /**
     * Visszatér egy popup-pal, amivel id-től függően, létrehozható vagy módosítható egy screen
     * @param string screenID
     */
    screen: function(screenID){
        var screenID = screenID || 0;

        $.post('/admin/screens/screen/' + screenID, {}, function(resp){
            popup(resp.html, resp.title).dialog();
        }, 'json');
    },
    /**
     * Létrehoz vagy módosít egy screen-t az id-től függően.
     * @param string screenID
     */
    save: function(screenID){
        var screenID = screenID || 0;
        var params = $('#screen-popup-form').find('select, input').serializeObj();

        $('#screen-popup-success i').toggle('fast')

        $.post('/admin/screens/save/' + screenID, params, function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
            $('#screen-popup-success i').toggle('fast')
        });
    },
    delete: function(screenID){
        var screenID = screenID || 0;

        $.post('/admin/screens/delete/' + screenID, {}, function(){
            location.reload();
        });
    }
};